export const INACTIVE_STATUS_REASONS = [
  'Account - Account deactivated',
  'Account - Device type not monitored',
  'Billing - Program cost',
  'Compliance - Not responsive to outreach',
  "Compliance - Won't connect to home monitor",
  'Device - End of service',
  'Device - Incompatible with remote monitoring',
  'Duplicate - Already Patient',
  'Eligibility - Insurance plan not covered',
  'Eligibility - Hospice',
  'Eligibility - Currently monitored elsewhere',
  'Eligibility - Moved, location not supported',
  'Eligibility - Incarcerated',
  'Eligibility - Unable to verify insurance',
  'Eligibility - Unable to verify demographics',
  'Medical - Physician request',
  'Medical - Clinic request',
  'Medical - Deceased',
  'Medical - Explanted',
  'Patient Request - Refused monitoring',
  "Compliance - Won't transmit",
  'Device - Unable to be remotely monitored',
  "Patient Request - Doesn't find value in monitoring",
  'Eligibility - Moved location',
  'Medical - Lost to follow up',
  'System - Auto-Created in Error',
  'Patient Request - In Clinic Only Monitoring',
  'Patient Request - Follows PRN',
  'Other'
];

export const PAUSED_STATUS_REASONS = ['Traveling', 'Hospital', 'Patient Request','Biotronik - Insufficient Data Window', 'Other'];

export const PATIENT_STATUS_OPTIONS = [
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' },
  { label: 'Paused', value: 'Paused' }
];
